/* /verify: the public certificate check, in the shell's master brand (white, near-black ink,
   Manrope; gold only as the small rule, never behind text). Small text uses --shell-ink-60 or
   darker, which keeps 4.5 to 1 on white. */
.vf-page { min-height: 100vh; display: flex; flex-direction: column; background: var(--shell-bg); color: var(--shell-ink); font-family: var(--shell-font); }
.vf-header { height: 76px; display: flex; align-items: center; padding: 0 64px; border-bottom: 1px solid var(--shell-ink-10); }
.vf-main { flex: 1; width: 100%; max-width: 720px; margin: 0 auto; padding: 64px 24px 80px; display: flex; flex-direction: column; gap: 14px; }
.vf-eyebrow { display: flex; align-items: center; gap: 10px; font-size: 13px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.vf-eyebrow::before { content: ''; width: 24px; height: 3px; background: var(--shell-gold); }
.vf-h1 { margin: 0; font-size: 40px; font-weight: 800; line-height: 1.1; letter-spacing: -0.01em; overflow-wrap: anywhere; }
.vf-lede { margin: 0; font-size: 18px; line-height: 1.6; color: var(--shell-ink-80); }
.vf-facts { margin: 18px 0 0; border-top: 1px solid var(--shell-ink-10); }
.vf-facts > div { display: grid; grid-template-columns: 160px minmax(0, 1fr); gap: 16px; padding: 14px 0; border-bottom: 1px solid var(--shell-ink-10); }
.vf-facts dt { font-size: 14px; font-weight: 700; color: var(--shell-ink-60); }
.vf-facts dd { margin: 0; font-size: 16px; font-weight: 600; overflow-wrap: anywhere; }
.vf-note { margin: 10px 0 0; font-size: 14px; line-height: 1.6; color: var(--shell-ink-60); }
.vf-actions { margin: 8px 0 0; }

@media (max-width: 760px) {
  .vf-header { height: 64px; padding: 0 16px; }
  .vf-main { padding: 40px 16px 56px; }
  .vf-h1 { font-size: 30px; }
  .vf-facts > div { grid-template-columns: minmax(0, 1fr); gap: 4px; }
}
